import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { METS_ENTERPRISE_NAV } from './metsEnterpriseAccess';

/**
 * Expandable hamburger submenu for METS Enterprise workspaces.
 */
function MetsEnterpriseSubmenu({ theme }) {
  const location = useLocation();
  const navigate = useNavigate();
  const onMetsRoute = location.pathname.startsWith('/mets');
  const [open, setOpen] = useState(onMetsRoute);
  const isDark = theme === 'dark';

  useEffect(() => {
    if (onMetsRoute) {
      setOpen(true);
    }
  }, [onMetsRoute]);

  const styles = {
    toggle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      padding: '12px 20px',
      color: isDark ? '#e0e0e0' : '#333',
      border: 'none',
      backgroundColor: onMetsRoute
        ? isDark
          ? 'rgba(255,255,255,0.06)'
          : 'rgba(0,0,0,0.04)'
        : 'transparent',
      width: '100%',
      textAlign: 'left',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 600,
    },
    caret: {
      fontSize: '11px',
      opacity: 0.75,
      flexShrink: 0,
    },
    childList: {
      padding: '0 0 4px',
      backgroundColor: isDark ? 'rgba(0,0,0,0.18)' : 'rgba(0,0,0,0.03)',
    },
    childItem: {
      display: 'block',
      padding: '10px 20px 10px 32px',
      color: isDark ? '#e0e0e0' : '#333',
      border: 'none',
      backgroundColor: 'transparent',
      width: '100%',
      textAlign: 'left',
      cursor: 'pointer',
      fontSize: '13px',
    },
  };

  const children = METS_ENTERPRISE_NAV.filter(
    (item) => location.pathname !== item.path
  );

  return (
    <div>
      <button
        type="button"
        style={styles.toggle}
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>METS Enterprise</span>
        <span style={styles.caret}>{open ? '▾' : '▸'}</span>
      </button>
      {open && (
        <div style={styles.childList} role="group" aria-label="METS Enterprise">
          {children.map((item) => (
            <button
              key={item.key}
              type="button"
              style={styles.childItem}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default MetsEnterpriseSubmenu;
